// Missions
export const SET_MISSIONS = 'SET_MISSIONS';
export const SET_MISSION = 'SET_MISSION';
export const SET_MISSION_LOADING = 'SET_MISSION_LOADING';
export const SET_MISSION_META_GROUPS = 'SET_MISSION_META_GROUPS';
export const SET_MISSION_IC_NOT_READY = 'SET_MISSION_IC_NOT_READY';

export const PUSH_MISSION_META_GROUPS_DISABLED = 'PUSH_MISSION_META_GROUPS_DISABLED';
export const REMOVE_MISSION_META_GROUPS_DISABLED = 'REMOVE_MISSION_META_GROUPS_DISABLED';
